// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"478":"530f0063","824":"9b4a3e9f","906":"5d03e508"}[chunkId] + ".chunk.js");